import { BYO_MARKET_NO_ROWS, CATEGORIES } from '../constants';
const globalConfig = (window.WH && window.WH.byo) || {
    locale: process.env.LOCALE || 'en-gb',
    dataServiceUrl: process.env.DATA_SERVICE_URL || '',
    betslipServiceEndpoint: process.env.BETSLIP_SERVICE_ENDPOINT || '',
    minimumSelections: 2,
    maximumSelections: 8,
    defaultOpenAccordions: 0,
    locationState: 'BYO_APP',
    tag: 'byo',
    platform: process.env.PLATFORM,
    useBYOFreedom: process.env.FREEDOM === 'true',
};
const disabledSiblingsButtonsOnCategories = [
    CATEGORIES.RESULT,
    CATEGORIES.BOTH_TEAMS_TO_SCORE,
    CATEGORIES.DOUBLE_CHANCE,
    CATEGORIES.FIRST_TEAM_TO_SCORE,
    CATEGORIES.TEAM_WITH_MOST_BOOKING_POINTS,
    CATEGORIES.MATCH_HANDICAP,
];
const marketsConfig = {
    [CATEGORIES.RESULT]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.BOTH_TEAMS_TO_SCORE]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_GOALS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_GOAL_KICKS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.TOTAL_CARDS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_CORNERS]: {
        columns: 2,
        rows: 11,
    },
    [CATEGORIES.DOUBLE_CHANCE]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.TEAM_WITH_MOST_CARDS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.CORRECT_SCORE]: {
        columns: 3,
        rows: 5,
    },
    [CATEGORIES.PLAYER_TO_SCORE]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_WITH_MOST_CORNERS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.FIRST_TEAM_TO_SCORE]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.COME_FROM_BEHIND]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.TOTAL_BOOKING_POINTS]: {
        columns: 2,
        rows: 5,
    },
    [CATEGORIES.TEAM_WITH_MOST_BOOKING_POINTS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.MATCH_HANDICAP]: {
        columns: 3,
        rows: 3,
    },
    [CATEGORIES.PLAYER_TO_BE_CARDED]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TOTAL_FREE_KICKS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.TOTAL_THROW_INS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.HIGHEST_SCORING_HALF]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.RED_CARD]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.QUALIFY_LIFT_THE_TROPHY]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.PLAYER_TO_ASSIST]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_SHOTS_ON_TARGET]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.METHOD_OF_GOAL]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TOTAL_SHOTS]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TOTAL_TACKLES]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TO_QUALIFY]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.MATCH_TO_GO_PENALTIES]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TO_WIN_ON_PENALTIES]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_TACKLES]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_SHOTS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TO_WIN_IN_EXTRATIME]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_SHOTS_ON_TARGET]: {
        columns: 2,
        rows: 4,
    },
    'DEFAULT': {
        columns: 3,
        rows: 3,
    },
};
const playerMarkets = new Set([
    'PLAYER_TO_BE_CARDED',
    'PLAYER_SHOTS_ON_TARGET',
    'PLAYER_TO_SCORE',
    'PLAYER_TO_ASSIST',
]);
const config = {
    get locale() { return globalConfig.locale || 'en-gb'; },
    get eventId() { return globalConfig.eventId || ''; },
    get dataServiceUrl() { return globalConfig.dataServiceUrl || ''; },
    get tag() { return globalConfig.tag || 'byo'; },
    get betslipServiceEndpoint() { return globalConfig.betslipServiceEndpoint || ''; },
    get minimumSelections() { return globalConfig.minimumSelections || 2; },
    get maximumSelections() { return globalConfig.maximumSelections || 8; },
    get defaultOpenAccordions() { return globalConfig.defaultOpenAccordions || 0; },
    get locationState() { return globalConfig.locationState || 'BYO_APP'; },
    get useBYOFreedom() { return globalConfig.useBYOFreedom; },
    get platform() { return globalConfig.platform || 'mobile'; },
    get byoFreedomEnabled() { return globalConfig.byoFreedomEnabled; },
    get byoMarketsEnabled() { return globalConfig.byoMarketsEnabled; },
    marketsConfig,
    disabledSiblingsButtonsOnCategories,
    playerMarkets,
};
export default config;
